import { render, staticRenderFns } from "./Ticket_Guia.vue?vue&type=template&id=4a0c8929&scoped=true&"
import script from "./Ticket_Guia.vue?vue&type=script&lang=js&"
export * from "./Ticket_Guia.vue?vue&type=script&lang=js&"
import style0 from "./Ticket_Guia.vue?vue&type=style&index=0&id=4a0c8929&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c8929",
  null
  
)

export default component.exports